import { useRef, type ReactNode } from "react";

export function EstadaRadioGroup<T extends string | boolean | number>({ label, value, options, onChange, disabled = false, className = "" }: {
  label: string;
  value: T;
  options: readonly { value: T; label: ReactNode }[];
  onChange: (value: T) => void;
  disabled?: boolean;
  className?: string;
}) {
  const buttons = useRef<(HTMLButtonElement | null)[]>([]);
  return <div className={`estadaRadioGroup ${className}`} role="radiogroup" aria-label={label} aria-disabled={disabled || undefined}>
    {options.map((option, index) => <button key={String(option.value)} ref={element => { buttons.current[index] = element; }}
      type="button" role="radio" aria-checked={option.value === value} disabled={disabled}
      className={option.value === value ? "active" : ""} tabIndex={option.value === value ? 0 : -1}
      onClick={() => onChange(option.value)}
      onKeyDown={event => {
        const step = event.key === "ArrowRight" || event.key === "ArrowDown" ? 1
          : event.key === "ArrowLeft" || event.key === "ArrowUp" ? -1 : 0;
        if (!step && event.key !== "Home" && event.key !== "End") return;
        event.preventDefault();
        const next = event.key === "Home" ? 0 : event.key === "End" ? options.length - 1
          : (index + step + options.length) % options.length;
        buttons.current[next]?.focus();
        onChange(options[next].value);
      }}>{option.label}</button>)}
  </div>;
}
